import { toast, ToastOptions } from 'react-toastify'
import { Box, Image, Text } from '@chakra-ui/react'

const toastify = {
  dismiss: toast.dismiss,
  error: (
    { title, description }: { title: string; description?: string },
    options?: ToastOptions<object> | undefined
  ) =>
    toast.error(
      <Box fontSize="14px">
        <Text fontWeight="600">{title}</Text>
        {description && <Text color="muted">{description}</Text>}
      </Box>,
      {
        autoClose: 3000,
        ...(options || {}),
      }
    ),
  warning: (
    { title, description }: { title: string; description?: string },
    options?: ToastOptions<object> | undefined
  ) =>
    toast.warning(
      <Box fontSize="14px">
        <Text fontWeight="600">{title}</Text>
        {description && <Text color="muted">{description}</Text>}
      </Box>,
      {
        autoClose: 3000,
        ...(options || {}),
      }
    ),
  info: (
    { title, description }: { title: string; description?: string },
    options?: ToastOptions<object> | undefined
  ) =>
    toast.info(
      <Box fontSize="14px">
        <Text fontWeight="600">{title}</Text>
        {description && <Text color="muted">{description}</Text>}
      </Box>,
      {
        autoClose: 3000,
        ...(options || {}),
      }
    ),
  success: (
    { title, description }: { title: string; description?: string },
    options?: ToastOptions<object> | undefined
  ) =>
    toast.success(
      <Box fontSize="14px">
        <Text fontWeight="600">{title}</Text>
        {description && <Text color="muted">{description}</Text>}
      </Box>,
      {
        autoClose: 2000,
        icon: (
          <Image
            src={'/static/icons/check-circle.svg'}
            w={'18px'}
            h={'18px'}
            alt={'check'}
          />
        ),
        ...(options || {}),
      }
    ),
}
export default toastify
